import { Command } from 'commander';
import { ApiClient } from '../client.js';
import { formatOutput, formatBatchResult } from '../output.js';
import { parseData, getBase, getFormat } from '../helpers.js';

export const batchCommand = new Command('batch')
  .description('Execute atomic batch operations (up to 1,000 operations)')
  .requiredOption('--operations <json>', 'Operations array (inline JSON or @filename)')
  .action(async function (this: Command, opts: { operations: string }) {
    const ws = getBase(this);
    const client = new ApiClient();
    const operations = parseData(opts.operations);
    const data = await client.request('POST', `/v1/${ws}/batch`, {
      operations: Array.isArray(operations) ? operations : [operations],
    });
    // The batch body is `{ batch_id, results: [...] }` — an object, so the generic table
    // formatter would cram the whole results array into one unreadable cell (#354). Render
    // a per-operation summary instead; `--output json` still yields the full payload.
    const format = getFormat(this);
    console.log(format === 'json' ? formatOutput(data, format) : formatBatchResult(data));
  });
